module.exports = __webpack_public_path__ + "static/media/check-white.b645505d.svg";